/* tslint:disable:react-a11y-anchors */
import * as React from 'react'

import { IItem } from '../../../../typings/searchResults'
import ImagePreview from '../../../components/imagePreview'
import ImagePreviewWithCarousel from '../../../components/imagePreviewWithCarousel'
import FeatureContainer from '../../../containers/feature/featureContainer'
import ImagePlaceholder from '../../imagePlaceholder'

interface IProps {
  item: IItem
  rank: number
  onItemLinkClick: React.EventHandler<any>
  carousel?: boolean
}

const Preview = ({ item, rank, onItemLinkClick, carousel = false }: IProps) => {
  const previewWithCarousel = (
    <ImagePreviewWithCarousel
      item={item}
      rank={rank}
      onItemLinkClick={onItemLinkClick}
    />
  )

  const previewWithoutCarousel = (
    <a href={`${item.url}?s_rank=${rank}`} onClick={onItemLinkClick}>
      <ImagePlaceholder ratio={0.5}>
        <ImagePreview item={item} />
      </ImagePlaceholder>
    </a>
  )

  return carousel ? previewWithCarousel : previewWithoutCarousel
}

export default Preview
